import { IProject } from "../models/project.model";

export const PROJECTS: IProject[] = [
    {
        slug: 'bunglow', // ! title + client + location
        title: 'Bunglow',
        project: 'Bunglow ',
        clients: '-',
        location: '-',
        year: '-',
        listViewDescription: "The Regal Haven by Kritajna Homes is a luxurious bungalow that epitomizes timeless design and bespoke craftsmanship, reflecting our 15 years of mastery in architecture and interiors. This sprawling residence harmonizes elegance, comfort, and functionality, creating an exquisite retreat for serene living.",
        listViewImageUrl: "/images/projects-images/bunglow/cover.jpeg",
        coverImageUrl: '/images/projects-images/bunglow/cover.jpeg',
        images: [
            "/images/projects-images/bunglow/bedroom.jpeg",
            "/images/projects-images/bunglow/dining-area.jpeg",
            "/images/projects-images/bunglow/living-area.jpeg",
            "/images/projects-images/bunglow/living-room-2.jpeg"
        ],
        pageTitle: 'Kritajna Homes: Bunglow',
        pageDescription: 'Bunglow'
    },
    {
        slug: 'cafe-cum-dining',
        title: 'Cafe cum dining',
        project: 'Cafe',
        clients: 'Cafe cum dining',
        location: 'Bhubneswar',
        year: '-',
        listViewDescription: "The Artisan Café by Kritajna Homes is a sophisticated space designed to elevate the dining experience, blending aesthetic appeal with warm, inviting functionality. Drawing on years of design excellence, we’ve created a haven for social connection and culinary indulgence, where every corner tells a story of refined artistry.",
        listViewImageUrl: "/images/projects-images/cafe/cafe-1.jpg",
        coverImageUrl: '/images/projects-images/cafe/cafe-1.jpg',
        images: [
            "/images/projects-images/cafe/cafe-2.png",
            "/images/projects-images/cafe/cafe-1.jpg",
            "/images/projects-images/cafe/cafe-3.png"
        ],
        pageTitle: 'Kritajna Homes: Cafe cum dining',
        pageDescription: 'Cafe cum dining'
    },
]